import React from 'react';

import { W2_WELCOME_IMAGE } from '../../copy';
import { WELCOME_COPY } from '../constants/copy';
import { W2_SELECT_TID } from '../constants/testids';
import { W2SelectionStepLayout } from './W2SelectionStepLayout';

const TID = W2_SELECT_TID.welcome;

interface SelectionWelcomeProps {
  onStart: () => void;
  /** Bar position (STEP n / m). */
  step: number;
  total: number;
}

/**
 * Returning-employee intro (client copy, screen 2), hosted in the two-panel
 * selection shell. The verbatim client copy (`Alia` / `Waive Coverage` bolded)
 * lives in the left maroon panel; the "Get Started" primary pill is the panel's
 * NEXT action (there is no Previous on the first screen).
 */
export const SelectionWelcome: React.FC<SelectionWelcomeProps> = ({
  onStart,
  step,
  total,
}) => {
  return (
    <W2SelectionStepLayout
      step={step}
      total={total}
      title={WELCOME_COPY.headline}
      body={
        <>
          <p>
            {
              "You're almost there! On the next few screens, you'll review the health plan and benefit options your employer has made available to you and select the coverage that's right for you."
            }
          </p>
          <p>
            {
              "We'll guide you through the process step by step. If additional benefits, such as dental, vision, or other optional coverage, are available, you'll have the opportunity to review and select those as well."
            }
          </p>
          <p>
            {
              'The process only takes a few minutes to complete. If you have any questions along the way, our AI assistant, '
            }
            <strong>Alia</strong>
            {
              ', is always available to help explain your options and make choosing your benefits simple.'
            }
          </p>
          <p>
            {
              "Important: You are not required to enroll in every benefit offered. If you decide not to enroll in a particular plan, you'll have the option to "
            }
            <strong>Waive Coverage</strong>
            {" at the top of that plan's page."}
          </p>
        </>
      }
      onNext={onStart}
      nextLabel="Get Started"
      nextTestId={TID.start}
      fullBleed
      reversed
    >
      {/* The B2C welcome treatment (`WelcomeForm` + `onlyImage`): ONE full-bleed
          image filling the card, image LEFT / maroon panel RIGHT (D4). Same
          asset as the PHQ welcome — `W2_WELCOME_IMAGE` is the single source. */}
      <div data-testid={TID.root} className="h-full min-h-100 w-full">
        <img
          src={W2_WELCOME_IMAGE}
          alt=""
          aria-hidden="true"
          className="h-full w-full rounded-2xl object-cover object-top"
        />
      </div>
    </W2SelectionStepLayout>
  );
};
